module.exports = __webpack_public_path__ + "img/ic-map-marker-active.c84b9ffa.svg";